import classNames from 'classnames'

export const getPcaData = async () => {
    let res = await import("@/assets/pca.json");
    const pcaData = res["default"];
    const result = Object.keys(pcaData).map((province) => {
        const citys = Object.keys(pcaData[province]).map((city) => {
            const areas = pcaData[province][city].map((area) => {
                return {
                    value: area,
                    label: area,
                }
            })
            return {
                value: city,
                label: city,
                children: areas,
            }
        })
        return {
            value: province,
            label: province,
            children: citys,
        }
    })
    return result
}

export const classModule = function (styles, ...classList) {
    let ary = [];
    if (classList.length) {
        classList[0] instanceof Array ? ary = classList[0] : ary = classList
    }
    const classnameList = ary.map(cla => styles[cla] || cla);
    return classNames(classnameList)
}
export const classModuleGenerator = function (styles) {
    return function (...classList) {
        return classModule(styles, classList?.[0] instanceof Array ? classList[0] : classList)
    }
}

const util = {
    getPcaData,
    classModule,
    classModuleGenerator
}

export default util